import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';

export class CloneAlbumItemsAPICall extends APICallV4 {
    _method = 'album/elements/clone';
    _type: Method = 'post';
}
